import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["how-hard-did-it-feel"]!;

export function Body() {
  return (
    <>
      <p>
        After each run PX7 Training asks you a simple question: how hard did the whole session
        feel? It may seem old-fashioned when your watch records heart rate every second. Here is
        the research behind the question.
      </p>

      <h2>What the researchers did</h2>
      <p>
        In 2001, Carl Foster and colleagues tested a simple way to measure training load. After
        a session, you rate how hard the whole session was on a scale from 0 to 10, and multiply
        that rating by the number of minutes. They called it session RPE.
      </p>
      <p>
        They compared it with a method based on heart rate, both in steady and interval cycling
        and in basketball practice.
      </p>

      <h2>What they found</h2>
      <p>
        The two methods followed each other consistently, both on the bike and on the court.
        Session RPE gave higher numbers than the heart rate method, but the relationship
        between them was stable. The researchers concluded that session RPE works across very
        different kinds of exercise, including hard intervals, where heart rate alone is harder
        to interpret.
      </p>

      <h2>What it means for you</h2>
      <p>
        How a session felt is real information. Heart rate lags behind in short intervals and is
        affected by heat, caffeine and sleep. Your own rating of the whole session captures what
        the watch can't, such as heavy legs or a stressful day.
      </p>
      <p>
        Rate the whole session, not the hardest moment, and try to do it the same way each
        time, for example a little while after you have finished.
      </p>

      <h2>What the study can't tell you</h2>
      <p>
        Session RPE describes how demanding a session was. It doesn't measure your fitness, and
        one high rating doesn't mean you are overtrained. A session can also feel hard because
        you are tired, not because it was a big workout.
      </p>

      <h2>How we use it</h2>
      <p>
        PX7 Training keeps your rating alongside what you actually ran. A hard rating doesn't
        count as extra training. If several comparable sessions feel clearly harder than
        expected, and you also report that you are tired, the next sessions become easier.
      </p>

      <h2>Source</h2>
      <ul>
        <li>
          Foster et al. (2001), A new approach to monitoring exercise training.{" "}
          <a href="https://pubmed.ncbi.nlm.nih.gov/11708692/">Journal of Strength and Conditioning Research</a>.
        </li>
      </ul>
    </>
  );
}
